import { AxiosInstance } from 'axios';
import { get, post, patch, del } from '../hooks/useAxiosPrivate';
import { JourneyTagEntity } from '../state/journeyTags/types';
import { SelectableColor } from '../aurora/colors/types';

interface GetJourneyTagsParams {
  limit?: number;
  page?: number;
  sortColumn?: keyof JourneyTagEntity;
  sortDirection?: 1 | -1;
  search?: string;
  paginate?: boolean;
}

const companyJourneyTagsUrl = (companyId: string) =>
  `/api/v1/company/${companyId}/journey-tags`;

const JourneyTagsApi = {
  getJourneyTags: async (
    axios: AxiosInstance,
    companyId: string,
    params?: GetJourneyTagsParams
  ): Promise<{ entities: JourneyTagEntity[]; totalPages: number }> => {
    const response = await get(axios, companyJourneyTagsUrl(companyId), params);
    return response.data;
  },
  createJourneyTag: async (
    axios: AxiosInstance,
    journeyTag: {
      name: string;
      color: SelectableColor;
    },
    companyId: string
  ): Promise<JourneyTagEntity> => {
    const response = await post(
      axios,
      companyJourneyTagsUrl(companyId),
      journeyTag
    );
    return response.data;
  },
  updateJourneyTag: async (
    axios: AxiosInstance,
    tagId: string,
    journeyInfo: { name: string; color: SelectableColor },
    companyId: string
  ): Promise<JourneyTagEntity> => {
    const response = await patch(
      axios,
      `${companyJourneyTagsUrl(companyId)}/${tagId}`,
      journeyInfo
    );
    return response.data;
  },
  deleteJourneyTags: async (
    axios: AxiosInstance,
    tagIds: string[],
    companyId: string
  ): Promise<void> => {
    await del(axios, companyJourneyTagsUrl(companyId), {
      data: { tagIds },
    });
  },
};

export default JourneyTagsApi;
